// frontend/src/config/gauges/ezchiller2compct6.js

export const ezChiller2CompCT6GaugeConfig = [
  // 1) Presión Succión C1
  {
    key: "presionSuccionComp1",
    title: "Presión Succión C1",
    unit: "psi",
    ranges: [
      { min: 0,  max: 27.99,  color: "red" },     
      { min: 28, max: 32.99,  color: "yellow" },  
      { min: 33, max: 40.99,  color: "green" },   
      { min: 41, max: 68.99,  color: "yellow" },  
      { min: 69, max: 10000, color: "red" },     
    ],
  },

  // 2) Presión Succión C2
  {
    key: "presionSuccionComp2",
    title: "Presión Succión C2",
    unit: "psi",
    ranges: [
      { min: 0,  max: 27.99,  color: "red" },     
      { min: 28, max: 32.99,  color: "yellow" },  
      { min: 33, max: 40.99,  color: "green" },   
      { min: 41, max: 68.99,  color: "yellow" },  
      { min: 69, max: 10000, color: "red" },     
    ],
  },

  // 3) Presión Descarga C1
  {
    key: "presionDescargaComp1",
    title: "Presión Descarga C1",
    unit: "psi",
    ranges: [
      { min: 0,   max: 139.99, color: "red" },
      { min: 140, max: 159.99, color: "yellow" },
      { min: 160, max: 210.99, color: "green" },
      { min: 211, max: 220.99, color: "yellow" },
      { min: 221, max: 26000, color: "red" },
    ],
  },

  // 4) Presión Descarga C2
  {
    key: "presionDescargaComp2",
    title: "Presión Descarga C2",
    unit: "psi",
    ranges: [
      { min: 0,   max: 139.99, color: "red" },
      { min: 140, max: 159.99, color: "yellow" },
      { min: 160, max: 210.99, color: "green" },
      { min: 211, max: 220.99, color: "yellow" },
      { min: 221, max: 26000, color: "red" },
    ],
  },

  // 5) Temp Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temperatura Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 0,  max: 4.99,  color: "red" },
      { min: 5,  max: 7.99,  color: "yellow" },
      { min: 8,  max: 14.99, color: "green" },
      { min: 15, max: 19.99, color: "yellow" },
      { min: 20, max: 50000, color: "red" },
    ],
  },

  // 6) Temp Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temperatura Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 0,   max: 4.99,   color: "red" },
      { min: 5,   max: 6.49, color: "yellow" },
      { min: 6.5, max: 11.99,  color: "green" },
      { min: 12,  max: 19.99,  color: "yellow" },
      { min: 20,  max: 5000,  color: "red" },
    ],
  },

  // 7) Temp Refrigerante Condensado C1 (equivale a tu tRef1)
  {
    key: "tempRefrCondensado1",
    title: "Temp. Refr. Condensado C1",
    unit: "°C",
    ranges: [
      { min: 0,  max: 24.99, color: "red" },
      { min: 25, max: 31.99, color: "yellow" },
      { min: 32, max: 39.99, color: "green" },
      { min: 40, max: 49.99, color: "yellow" },
      { min: 50, max: 20000, color: "red" },
    ],
  },

  // 8) Temp Refrigerante Condensado C2 (equivale a tu tRef2)
  {
    key: "tempRefrCondensado2",
    title: "Temp. Refr. Condensado C2",
    unit: "°C",
    ranges: [
      { min: 0,  max: 24.99, color: "red" },
      { min: 25, max: 31.99, color: "yellow" },
      { min: 32, max: 39.99, color: "green" },
      { min: 40, max: 49.99, color: "yellow" },
      { min: 50, max: 20000, color: "red" },
    ],
  },

  // 9) Temp Descarga C1
  {
    key: "tempDescargaComp1",
    title: "Temperatura Descarga C1",
    unit: "°C",
    ranges: [
      { min: 0,   max: 39.99,  color: "red" },
      { min: 40,  max: 59.99,  color: "yellow" },
      { min: 60,  max: 89.99,  color: "green" },
      { min: 90,  max: 99.99, color: "yellow" },
      { min: 100, max: 20000, color: "red" },
    ],
  },

  // 10) Temp Descarga C2
  {
    key: "tempDescargaComp2",
    title: "Temperatura Descarga C2",
    unit: "°C",
    ranges: [
      { min: 0,   max: 39.99,  color: "red" },
      { min: 40,  max: 59.99,  color: "yellow" },
      { min: 60,  max: 89.99,  color: "green" },
      { min: 90,  max: 99.99, color: "yellow" },
      { min: 100, max: 20000, color: "red" },
    ],
  },
];
